import DataType from '@opsbase/lib-datatype/DataType/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useTeamboardCreate from '@opsbase/react-gql-hooks/teamboard/useTeamboardCreate';
import useNewDataActionsContext from '@opsbase/web-ctrl-newdata/useNewDataActions';
import PlaceChooser from '@opsbase/web-data-choosers/PlaceChooser';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
export function TeamboardCreateDialog() {
    const { raise } = useNotificationActions();
    const createTeamboard = useTeamboardCreate();
    const [title, setTitle] = useState('');
    const [place, setPlace] = useState();
    const { replaceTo } = useNav();
    const { addItemsToType } = useNewDataActionsContext();
    const handleClickCreate = useCallback(() => {
        return raise(createTeamboard({
            patch: { title, place: { id: place.id } },
        }), i18n.t('teamboard-create-successful'));
    }, [raise, createTeamboard, place, title]);
    const handleAfterCreate = useCallback(teamboard => {
        addItemsToType(DataType.TEAMBOARD, [teamboard]);
        replaceTo(Pages.TEAMBOARDS_EDIT, { id: teamboard.id });
    }, [addItemsToType, replaceTo]);
    const handleChangePlace = useCallback(sites => setPlace((sites === null || sites === void 0 ? void 0 : sites.length) ? sites[0] : undefined), []);
    return (React.createElement(CreateDialog, { valid: !!title && !!place, onCreate: handleClickCreate, afterCreate: handleAfterCreate, title: i18n.t('create-a-teamboard') },
        React.createElement(Vertical, { gutter: true },
            React.createElement(Pane, { style: { margin: '0 28px' } },
                React.createElement(TextFieldWithStateAndBlur, { white: true, label: i18n.t('title'), autoFocus: true, value: title, onBlur: setTitle, fullWidth: true })),
            React.createElement(Pane, { style: { margin: '0 28px' } },
                React.createElement(Text, { variant: "h3" }, i18n.t('teamboard-place')),
                React.createElement(PlaceChooser, { required: true, value: place ? [place] : [], onChange: handleChangePlace })))));
}
export default TeamboardCreateDialog;
